    export const Vouchers_Action_Types = {
    FETCH_VOUCHERS_START: "vouchers/FETCH_VOUCHERS_START",
    FETCH_VOUCHERS_SUCCESS: "vouchers/FETCH_VOUCHERS_SUCCESS",
    FETCH_VOUCHERS_LIST_BY_TYPE: "packages/FETCH_VOUCHERS_LIST_BY_TYPE",
    FETCH_VOUCHERS_FAILED: "vouchers/FETCH_VOUCHERS_FAILED",
    SET_PAGE_SIZE: "vouchers/SET_PAGE_SIZE",
    SET_IS_UPDATED: "vouchers/SET_IS_UPDATED",
    SET_PAGE_NUMBER: "vouchers/SET_PAGE_NUMBER",
    SET_FILTER_SEARCH_STRING: "vouchers/SET_FILTER_SEARCH_STRING",
    }